import React from 'react'
import projectImg from '../assets/img/projects.png'
const Project = () => {
  return (
    <>
     <section className="project section">
                    <div className="project__bg">
                        <div className="project__container container ">
                            <div className="project__data">
                                    <h2 className="project__title">More projects</h2>
                                    <p className="project__description">More projects available on github</p>
                                    <a  href="https://github.com/renuka-rathva"
                  rel="noreferrer"
                  target={"_blank"}  className="button button--flex button--white">
                                        Check out <i className='uil uil-message project__icon button__icon'></i>
                                    </a>
                            </div>
                            <img src={projectImg} alt="" className="project__img"/>
                        </div>
                    </div>
            </section>
    </>
  )
}

export default Project